import styled from 'styled-components';
import { KiperButton } from '@kiper/ui';

export const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
  text-align: ${({ $align }) => $align || 'left'};
`;

export const Paragraph = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
  text-align: ${({ $align }) => $align || 'left'};

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }
`;

export const SectionHeading = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
  text-align: left;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SubmitButton = styled(KiperButton)`
  font-family: inherit;
  width: 100%;
  height: 44px;
  border-radius: 8px;
`;

export const StatusMessage = styled.p`
  margin: 0;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.45;
  background-color: ${({ theme, $variant }) =>
    $variant === 'success'
      ? theme.colors.semantic.status.success
      : theme.colors.semantic.status.danger};
  color: ${({ theme, $variant }) =>
    $variant === 'success' ? theme.colors.success500 : theme.colors.danger500};
`;

export const SupportLink = styled.a`
  color: ${({ theme }) => theme.colors.porterBlue500};
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const LegalNotice = styled.small`
  display: block;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
  text-align: ${({ $align }) => $align || 'center'};
`;
